export default __webpack_public_path__ + "static/media/team84.dded0346.JPG";